"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledEmptyTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _SectionTitle = _interopRequireDefault(require("../TitlesAndTexts/SectionTitle"));

var _Button = _interopRequireDefault(require("../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledEmptyTable = _styledComponents.default.div.withConfig({
  displayName: "EmptyTable__StyledEmptyTable",
  componentId: "design-system__yo2c94-0"
})(["min-height:400px;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);

exports.StyledEmptyTable = StyledEmptyTable;

const SubMessage = _styledComponents.default.span.withConfig({
  displayName: "EmptyTable__SubMessage",
  componentId: "design-system__yo2c94-1"
})(["font-family:", ";font-size:", ";color:", ";line-height:27px;margin-bottom:27px;", ""], _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.lightgray, _ref => {
  let {
    hasTitle
  } = _ref;
  return !hasTitle && 'margin-top: 2.5rem;';
});

const EmptyTable = _ref2 => {
  let {
    emptyTableMessage,
    emptyTableTitle,
    buttonMessage,
    buttonOnClick
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(StyledEmptyTable, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "empty_folder",
    size: "310"
  }), emptyTableTitle && /*#__PURE__*/_react.default.createElement(_SectionTitle.default, null, emptyTableTitle), emptyTableMessage && /*#__PURE__*/_react.default.createElement(SubMessage, {
    hasTitle: emptyTableTitle
  }, emptyTableMessage), buttonMessage && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "outlined",
    profile: "primary",
    onClick: buttonOnClick
  }, buttonMessage));
};

EmptyTable.propTypes = {
  emptyTableMessage: _propTypes.default.string,
  emptyTableTitle: _propTypes.default.string,
  buttonMessage: _propTypes.default.string,
  buttonOnClick: _propTypes.default.func
};
EmptyTable.defaultProps = {
  emptyTableMessage: '',
  emptyTableTitle: null,
  buttonMessage: null,
  buttonOnClick: null
};
var _default = EmptyTable;
exports.default = _default;